<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Edit Customer Relation') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.put(route('admin.customer-relations.update', supplierCustomerRelation.id))">
                <form-fields :form="form" :supplier="supplier" :supplier-customer-relation="supplierCustomerRelation" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'supplier',
            'supplierCustomerRelation',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    customer_number: this.supplierCustomerRelation.customer.customer_number,
                    internal_customer_number: this.supplierCustomerRelation.internal_customer_number,
                    notes: this.supplierCustomerRelation.notes,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>